import {createReducer} from '@reduxjs/toolkit';
import {
    getSubscriptionPackagesSuccess,
} from 'src/openapi/admin/apis/ContractControllerApi';

import type {PackagesListDto} from '../../typedef';


export type State = PackagesListDto;

const defaultState: State = [];

export const packagesData = createReducer(defaultState, builder => builder
    .addCase(getSubscriptionPackagesSuccess, (state, action) => {
        return action.payload.data;
    }),
);
